import React, { Component } from "react";
// import { withRouter } from "react-router-dom";
import { inject, observer } from "mobx-react";
import PropTypes from "prop-types";

@observer
// @withRouter
class Search extends Component {
	static propTypes = {
		_ladderStore: PropTypes.object,
		history: PropTypes.object
	}
	static defaultProps = {
		_ladderStore: {},
		history: {}
	}
	state = {
		keyword: "",
		list: []
	}
	render() {
		const { keyword, list } = this.state;
		const hr = list.map(v => <li key={v} className="tran-fast ellipsis" onClick={() => this.setState({ keyword: v })}>{v}</li>);
		return (
			<form className="ladder-search clearfix pr">
				<input
					type="text"
					placeholder="请输入BattleTag搜索"
					value={keyword}
					maxLength="30"
					onFocus={this.toggleHR.bind(this, true)}
					onBlur={() => setTimeout(() => this.toggleHR(false), 500)}
					onKeyPress={this.enterSearch.bind(this)}
					onChange={e => this.setState({ keyword: e.target.value })}
				/>
				<ul className={list.length ? "show" : ""}>{hr}</ul>
				<button type="button" onClick={this.search.bind(this)}>搜 索</button>
			</form>
		);
	}
	async search() {
		const { history } = this.props;
		const { _ladderStore } = Store;
		const keyword = this.state.keyword.replace(/(^\s*)|(\s*$)/g, "");
		if (!keyword) return;
		await _ladderStore.getTarget(keyword);
		let hr = JSON.parse(localStorage.getItem("hr")) || [];
		hr.unshift(keyword);
		hr = Array.from(new Set(hr));
		hr.length > 6 && hr.pop();
		localStorage.setItem("hr", JSON.stringify(hr));
		const { target } = _ladderStore;
		history.push(`/ladder/target${target ? `?btag=${target.battleTag}` : ""}`);
	}
	enterSearch(e) {
		if (e.nativeEvent.keyCode === 13) {
			e.preventDefault();
			this.search();
		}
	}
	toggleHR(toggle) {
		this.setState({ list: toggle ? JSON.parse(localStorage.getItem("hr")) || [] : [] });
	}
}
export default Search;